
    /**
     * @Author: sunchao
     * @Date:   2019/5/27 14:11
     */
    import {Component, Watch, Vue} from "vue-property-decorator";
    import {getUserInfo} from "../api/index";
    import Step from "@/components/Step.vue";
    import utils from "@/util";
    import config from "../../public/js/config";

    @Component({
        components: {
            Step,
        },
    })
    export default class Info extends Vue {
        private active: number = 1;
        private cardNum: string = "";
        private userName: string = "";
        private enable: boolean = true;
        private isReadOnly: boolean = false;
        private userNameError: boolean = false;
        private cardNumError: boolean = false;
        private cardNumErrorText: string = "";

        private async created() {
            this.checkIsFirstAuth();
        }

        @Watch("cardNum")
        private handleCardNum(val: string, oldVal: string) {
            val ? (this.cardNumError = false) : (this.cardNumError = true);
        }

        @Watch("userName")
        private handleUserName(val: string, oldVal: string) {
            val ? (this.userNameError = false) : (this.userNameError = true);
        }

        /**
         * 实人认证页面
         */
        private realAuthentication(): void {
            this.$router.push({path: `/real-authentication`});
        }

        /**
         * 检查姓名是否填写
         */
        private checkUserNameNotBlank(): boolean {
            if (!this.userName) {
                this.userNameError = true;
                return false;
            }
            return true;
        }

        /**
         * 检查身份证是否填写
         */
        private checkIdNumNotBlank(): boolean {
            if (!this.cardNum) {
                this.cardNumError = true;
                this.cardNumErrorText = "";
                return false;
            } else {
                this.cardNumError = false;
                return true;
            }
        }

        /**
         * 验证身份证格式是否正确
         */
        private checkIdNum(): boolean {
            if (!utils.checkIdNum(this.cardNum)) {
                this.cardNumErrorText = "身份证格式不正确！";
                return false;
            }
            return true;
        }

        /**
         * 检查是否为第一次实人认证
         * @param userGuid
         */
        private checkIsFirstAuth() {
            getUserInfo().then((resp: any) => {
                if (resp.succ===true) {
                    this.enable = false;
                    this.cardNum = resp.data.idNum;
                    this.userName = resp.data.realName;
                    this.isReadOnly = true;
                }else {
                    this.$dialog.alert({
                        message: "非法操作",
                    }).then(() => {
                        window.location.href = config.wechatBase + "#/userCenter";
                    });
                }
            });
        }
    }
